import React from "react";
import { useParams } from "react-router-dom";
import PageContent from "2g-page-content";

import DoplnkovaSluzbaDetailComponent from "b2b/components/doplnkova-sluzba-detail/DoplnkovaSluzbaDetail";

export function DoplnkovaSluzbaDetail() {
  const { id } = useParams();

  return (
    <PageContent>
      <DoplnkovaSluzbaDetailComponent id={id} />
    </PageContent>
  );
}

DoplnkovaSluzbaDetail.propTypes = {};

export default React.memo(DoplnkovaSluzbaDetail);
